import {Depots} from 'components/manufacturer/DepotSettings/depotApi';
import {AppApi} from 'store/customer/api';

const DepotApi = AppApi.injectEndpoints({
    endpoints: (build) => ({
        getDepots: build.query<Depots, void>({
            query: () => `/depots?page_size=999`,
            transformResponse: (response: {data: Depots}) => {
                return response.data;
            },
            providesTags: () => [
                {
                    type: 'Depot',
                },
            ],
        }),
        getCustomerDepots: build.query<Depots, void>({
            query: () => `/customer/depots?page_size=999`,
        }),
    }),
    overrideExisting: false,
});

export const {useGetDepotsQuery, useGetCustomerDepotsQuery} = DepotApi;
